import React from "react";

export class SelectionUiWrapper extends React.Component {
  render() {
    return (
      <div style={{ height: '100%', width: '100%', marginTop:'1vh'}}>
        <div style={{ backgroundColor:this.props.showWhite?'white':'#515151', height: '100%', width: '100%', boxShadow: "var(--box-shadow-stripe)", borderRadius: 10, marginTop: 5 }}>
          {this.props.children}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/components/selectionMenu/selectionUiWrapper.jsx